import { render, staticRenderFns } from "./ExpertLayout.vue?vue&type=template&id=5d3aee22&scoped=true"
import script from "./ExpertLayout.vue?vue&type=script&lang=js"
export * from "./ExpertLayout.vue?vue&type=script&lang=js"
import style0 from "./ExpertLayout.vue?vue&type=style&index=0&id=5d3aee22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3aee22",
  null
  
)

export default component.exports